import { motion } from "framer-motion";

export const KpiPanel = ({ kpis }) => (
  <div data-testid="kpi-panel" className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
    {kpis.map((k, i) => (
      <motion.div
        key={k.label}
        data-testid={`kpi-card-${i}`}
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.6, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
        className="group rounded-sm border border-sand bg-white/85 p-6 shadow-[0_4px_24px_rgba(31,110,90,0.05)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-gold/60 hover:shadow-[0_12px_32px_rgba(200,169,106,0.15)] sm:p-7"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-graphite/50">
          {k.label}
        </p>
        <p className="mt-3 font-serif text-3xl font-semibold text-jade transition-colors duration-300 group-hover:text-gold sm:text-4xl">
          {k.value}
        </p>
        <p className="mt-3 border-t border-sand/70 pt-3 text-xs leading-relaxed text-graphite/55">
          {k.note}
        </p>
      </motion.div>
    ))}
  </div>
);
